import { get } from "./api";
import { projects } from "../stores/store";
import { get as getFromStore } from "svelte/store";

//return all projects 
export const getProjects = async () => {
    if (true || !getFromStore(projects)) {
        const url = `/readprojects`;
        // const url = `/projects`;
        const response = await get(url);
        projects.set(response.data);
        console.log("projects url> ", url);
    }
    return projects;
};


